import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { getAllTexture } from "../Actions/texture";
import { Reducers } from "../Reducers";

export const store = createStore(Reducers,compose(applyMiddleware(thunk)));

//initialize
store.dispatch(getAllTexture());